<template>
    <form @submit.prevent>
        <h6 class="heading-small text-muted mb-4">ข้อมูลอื่นๆ</h6>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        ข้อมูลใบเสร็จ
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ข้อมูลใบเสร็จ"
                        v-model="other.receipt"
                    />
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        ข้อมูลท้ายใบเสร็จ
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ข้อมูลท้ายใบเสร็จ"
                        v-model="other.footerReceipt"
                    />
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>Size ใบปะหน้า</label>
                    <b-form-select v-model="other.sizeLabel" :options="size"></b-form-select>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>QR CODE</label>
                    <input
                        type="url"
                        class="form-control"
                        placeholder="ตัวอย่าง https://www.domain-name.com/"
                        v-model="other.qrCode"
                    />
                </div>
            </div>
        </div>
        <hr class="my-4" />
        <div class="row">
            <div class="col-lg-12">
                <!-- cctv -->
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> คุณมีกล้องวงจรปิดหรือไม่
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio v-model="other.cctv" name="cctv" value="YES">มี และสามารถบันทึกย้อนหลังได้อย่างน้อย 30 วัน</b-form-radio>
                            <b-form-radio v-model="other.cctv" name="cctv" value="NO">ไม่มี</b-form-radio>
                        </b-form-group>
                    </div>
                </div>
                <!-- scanner -->
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> คุณมีเครื่องสแกนบาร์โค้ดหรือไม่
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio v-model="other.scanner" name="scanner" value="YES">มี</b-form-radio>
                            <b-form-radio v-model="other.scanner" name="scanner" value="NO">ไม่มี</b-form-radio>
                        </b-form-group>
                    </div>
                </div>
                <!-- parking -->
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> คุณมีที่จอดรถหรือไม่ (กรณีจอดรถส่งพัสดุ และเข้ารับพัสดุ)
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio v-model="other.parking" name="parking" value="YES">มี</b-form-radio>
                            <b-form-radio v-model="other.parking" name="parking" value="NO">ไม่มี</b-form-radio>
                        </b-form-group>
                    </div>
                </div>
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ระบบปฏิบัติการโทรศัพท์ที่หน้าร้านใช้งาน (หากมีหลายเครื่อง สามารถระบุเพิ่มได้)
                    </label>
                    <div class="row" v-for="( system , index ) in optionsOperationSystem" :key="system.name">
                        <div class="col-lg-4">
                            <b-form-group>
                                <b-form-checkbox
                                    @change="clearInputOperationSystem(index)"
                                    v-model="other.operationSystem"
                                    class="m-2"
                                    :value="system.item"
                                    :state="($v.other.operationSystem.$error) ? false : null"
                                >
                                    {{system.name}}
                                </b-form-checkbox>
                            </b-form-group>
                        </div>
                        <div class="col-lg-6">
                            <input
                                v-if="system.key == 'other'"
                                type="text"
                                class="form-control"
                                :class="{ 'is-invalid': submittEdit && $v.other.operationSystemOther.$error }"
                                ref="other"
                                :placeholder="'อื่นๆ โปรดระบุ'"
                                :disabled="disableOperationSystem()"
                                @input="mapInputOperationSystem(index , $event.target.value)"
                            />
                            <label
                                v-if="system.key == 'other' && submittEdit && !$v.other.operationSystemOther.required"
                                class="invalid-feedback d-block">กรุณากรอกรายละเอียด
                            </label> 
                        </div>
                    </div>
                </div>
                <!-- sell-service -->
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> คุณยินดีที่จะขายบริการเสริมอื่นๆที่หน้าร้านหรือไม่ เช่น พรบ.ประกัน รับชำระค่าน้ำค่าไฟ
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio v-model="other.sellService" name="sell-service" value="YES">สนใจ ยินดีเปิดทุกบริการที่ {{configPOPTheme.webTitle}} SHOP มี</b-form-radio>
                            <b-form-radio v-model="other.sellService" name="sell-service" value="HOWEVER">สนใจ ยินดีเปิดบางบริการ ขอพิจารณาก่อน</b-form-radio>
                            <b-form-radio v-model="other.sellService" name="sell-service" value="NO">ไม่สนใจ</b-form-radio>
                        </b-form-group>
                    </div>
                </div>
                <!-- other-service -->
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> คุณสนใจหรือไม่ หากในอนาคต {{configPOPTheme.webTitle}} SHOP จะมีสินค้าและบริการอื่นๆ เพื่อเป็นช่องทางสร้างรายได้ เสริมให้กับร้านของคุณ
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio v-model="other.otherService" name="other-service" value="YES">สนใจ ทาง {{configPOPTheme.webTitle}} จะติดต่อกลับ</b-form-radio>
                            <b-form-radio v-model="other.otherService" name="other-service" value="NO">ไม่สนใจ ทาง {{configPOPTheme.webTitle}} จะไม่ติดต่อเพื่อรบกวนคุณ</b-form-radio>
                        </b-form-group>
                    </div>
                </div>
            </div>
        </div>
        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-4">ข้อมูลไปรษณีย์ไทย</h6>
        <!-- pickupthp-service -->
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> คุณสนใจให้ไปรษณีย์ไทยเข้ารับพัสดุหรือไม่
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio v-model="other.pickupTHP" :state="($v.other.pickupTHP.$error) ? false : null"  name="pickupTHP" value="YES">สนใจ ให้ไปรษณีย์ไทยเข้ารับ</b-form-radio>
                            <b-form-radio v-model="other.pickupTHP" :state="($v.other.pickupTHP.$error) ? false : null"  name="pickupTHP" value="NO">ไม่สนใจ ให้ไปรษณีย์ไทยเข้ารับ</b-form-radio>
                        </b-form-group>
                    </div>
                </div>
                <template v-if="other.pickupTHP == 'YES'">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> คุณสะดวกให้ไปรษณีย์ไทยเข้ารับพัสดุกี่โมง
                        </label>
                        <div class="col-lg-6">
                            <b-form-select v-model="other.timePickupTHP" :state="($v.other.timePickupTHP.$error) ? false : null" :options="timePickupTHP"></b-form-select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> จำนวนพัสดุที่ส่งกับไปรษณีย์ต่อวัน (ชิ้น)
                        </label>
                        <div class="col-lg-6">
                            <input
                                type="number"
                                class="form-control hide-arrow"
                                :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                placeholder="ชิ้น/ต่อวัน"
                                :class="{ 'is-invalid': submittEdit && $v.other.numsOrderTHP.$error }"
                                v-model="other.numsOrderTHP"
                            />
                            <label
                                v-if="submittEdit && !$v.other.numsOrderTHP.required"
                                class="invalid-feedback"
                            >กรุณากรอกจำนวนพัสดุที่ส่งกับไปรษณีย์ต่อวัน</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> เลือกรถไปรษณีย์เข้ารับ
                        </label>
                        <div class="col-lg-12">
                            <b-form-group>
                                <b-form-radio v-model="other.typeCarTHP" :state="($v.other.typeCarTHP.$error) ? false : null" name="typeCarTHP" value="TRUCK">รถใหญ่</b-form-radio>
                                <b-form-radio v-model="other.typeCarTHP" :state="($v.other.typeCarTHP.$error) ? false : null" name="typeCarTHP" value="MOTORCYCLE">รถเล็ก (มอเตอร์ไซค์)
                                    <small class="text-muted">* ข้อดี : สามารถเข้ารับพัสดุได้เร็วกว่า (สำหรับพัสดุชิ้นเล็ก)</small>
                                </b-form-radio>
                            </b-form-group>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <template v-if="$USER_LOGIN.get().isAdmin">
            <hr class="my-4" />
            <div class="mt-4 w-100 text-right">
                <b-button variant="secondary" @click="resetForm()">กรอกใหม่</b-button>
                <b-button type="submit" variant="info" @click="createOrUpdateOther()">บันทึก</b-button>
            </div>
        </template>
    </form>
</template>

<script>
import {
  required,
  requiredIf,
  url
} from "vuelidate/lib/validators"
import configPOPTheme from '@/config/POPTheme'
import validatePop from "@/plugins/validatePop.js"
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
import labelSize from '@/plugins/sizeLabel.js';

export default {
    name:"BranceOther",
    props: {
        submittEdit: Boolean,
        other: Object,
    },
    data(){
        return{
            size: labelSize,
            timePickupTHP: [
                { value: null, text: 'เลือกเวลาเข้ารับพัสดุ' },
                { value: "12:00:00", text: '12:00' },
                { value: "13:00:00", text: '13:00' },
                { value: "14:00:00", text: '14:00' },
                { value: "15:00:00", text: '15:00' },
                { value: "16:00:00", text: '16:00' },
                { value: "17:00:00", text: '17:00' },
            ],
            configPOPTheme: configPOPTheme
        }
    },
    validations: {
        other:{
            operationSystem:{ required },
            operationSystemOther:{ required: requiredIf(function (other) {
                return !this.disableOperationSystem() && this.mapOperationSystem()
            })},
            pickupTHP:{ required },
            timePickupTHP:{ required: requiredIf(function (other) {
                return other.pickupTHP == 'YES'
            })},
            numsOrderTHP:{ required: requiredIf(function (other) {
                return other.pickupTHP == 'YES'
            })},
            typeCarTHP:{ required: requiredIf(function (other) {
                return other.pickupTHP == 'YES'
            })},
            qrCode: { url }
        }
    },
    mounted(){
        console.log( this.size )
    },
    methods:{
        clearInputOperationSystem(index){
            if(this.optionsOperationSystem[index].item.hasOwnProperty('other')){
                this.optionsOperationSystem[index].item['other'] = ''
                this.$refs['other'][0].value = "";
            }
        },
        mapInputOperationSystem( index , value ){
            let i = this.other.operationSystem.findIndex(system => {
                return typeof system === 'object' && system !== null
            });
            if( i > -1 ){
                this.other.operationSystem[i]['other'] = value  
            }
            this.optionsOperationSystem[index].item['other'] = value    
        },
        mapOperationSystem(){
            let index = this.optionsOperationSystem.findIndex(system => {
                return system.key == 'other'
            });
            if( index > -1 && this.optionsOperationSystem[index].item['other'] == '' ){
                return true;
            }
            return false;
        },
        disableOperationSystem(){
            return !this.other.operationSystem.some(item => Object.keys(item) == 'other') 
        },
        createOrUpdateOther(){
            this.$emit('update:submittEdit', true);
            this.$v.other.$touch();
            if (this.$v.other.$invalid) {
                return false
            }
            this.$emit('handleLoader');
            this.$http
                .post(
                this.$API_URL + "/shop/shop/detail",
                {
                    type: "other",
                    detail: this.other.receipt,
                    footer_receipt: this.other.footerReceipt,
                    default_label_size: this.other.sizeLabel,
                    qrcode_receipt: this.other.qrCode,
                    cctv: this.other.cctv,
                    barcode_scanner: this.other.scanner,
                    parking: this.other.parking,
                    operating_system: this.other.operationSystem,
                    sell_service: this.other.sellService,
                    other_service: this.other.otherService,
                    pickup_thp: this.other.pickupTHP,
                    time_pickup_thp: this.other.timePickupTHP,
                    nums_order_thp: this.other.numsOrderTHP,
                    type_car_thp: this.other.typeCarTHP
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                }
                )
                .then(res => {
                    let checkError = validatePop( res )
                    this.$emit('handleLoader');
                    if( !checkError.status ){
                        showErrorModal( checkError.msg )
                        return false
                    }
                    showSuccessModal('บันทึกข้อมูลอื่นๆสำเร็จ')
                })
                .catch(error => {
                });
        },
        resetForm(){
            Object.keys(this.other).forEach(key => {
                if(['cctv','scanner','parking','sellService','otherService'].includes(key)){
                    this.other[key] = 'YES';
                }else if(key == 'operationSystem'){
                    let i = this.other[key].findIndex(system => {
                        return typeof system === 'object' && system !== null
                    });
                    if( i > -1 ){
                        this.other[key][i]['other'] = ''; 
                        this.$refs['other'][0].value = ""; 
                    }
                    this.other[key] = [];
                }else if(key == 'sizeLabel'){
                    this.other[key] = "A5";
                }else{
                    this.other[key] = '';
                }
            });
        }
    },
    computed:{
        optionsOperationSystem(){
            return[
                { item: 'android', name: 'Android', key:'android' },
                { item: 'ios', name: 'IOS', key:'ios' },
                { item: 'androidIos', name: 'ทั้ง Android และ IOS', key:'androidIos'  },
                { item: {other:''}, name: 'อื่นๆ โปรดระบุ', key:'other' },
            ]
        },
    }
}
</script>

<style>

</style>